import { render, staticRenderFns } from "./TexrareaInput.vue?vue&type=template&id=12b97cdc&"
import script from "./TexrareaInput.vue?vue&type=script&lang=js&"
export * from "./TexrareaInput.vue?vue&type=script&lang=js&"
import style0 from "./TexrareaInput.vue?vue&type=style&index=0&id=12b97cdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports